<template lang="pug">
  #listPasswordBusiness
    .table-view-header
      .table-view-header-title
        h3 Contraseñas de empresa
      .table-view-header-actions
        b-button.btn-create(@click="showCreatePasswordBusinessModal" size="sm") + Crear
    b-table(:items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(Acciones)="data")
        .table-actions
          b-button(@click="showEditPasswordBusinessModal(data.value.password)", size="sm", variant="light")
            font-awesome-icon(:icon="['far', 'edit']" size="lg" style="color: #7F828F")
          b-button(@click="showDeletePasswordBusinessModal(data.value.password)", size="sm", variant="light")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg" style="color: #7F828F")
    //- Modals
    b-modal(v-model="showCreateModal", size="lg" :hide-footer="true", title="Crear contraseña en empresa")
      CreateEditForm(v-if="showCreateModal", :hideModal="hideCreateModal", action="create", :makeToast="makeToast") 
    b-modal(v-model="showEditModal", size="lg" :hide-footer="true", title="Editar contraseña en empresa")
      CreateEditForm(v-if="showEditModal", title="Editar contraseña", action="edit", :hideModal="hideEditModal", :selectedPassword="selectedPassword", :makeToast="makeToast")
    b-modal(v-model="showDeleteModal", :hide-footer="true", :hide-header="true")
      DeletePassword(v-if="showDeleteModal", :hideModal="hideDeleteModal", :selected="selectedPassword", :makeToast="makeToast")
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CreateEditForm from "./CreateEditForm";
import DeletePassword from "./DeletePassword";
export default {
  components: {
    CreateEditForm,
    DeletePassword
  },
  data() {
    return {
      selectedPassword: {},
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false
    };
  },
  computed: {
    ...mapGetters(["business"]),
    tableItems() {
      if (this.business.passwords) {
        return this.business.passwords.map(p => {
          return {
            Contraseña: p.password,
            Usuario: p.user,
            Portal: p.portal,
            Descripción: p.description,
            Acciones: { password: p }
          };
        });
      }
      return [];
    }
  },
  methods: {
    ...mapActions(["getBusiness"]),
    showEditPasswordBusinessModal(password) {
      this.selectedPassword = password;
      this.showEditModal = true;
    },
    async hideEditModal() {
      this.showEditModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    showDeletePasswordBusinessModal(password) {
      this.selectedPassword = password;
      this.showDeleteModal = true;
    },
    async hideDeleteModal() {
      this.showDeleteModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    showCreatePasswordBusinessModal() {
      this.showCreateModal = true;
    },
    async hideCreateModal() {
      this.showCreateModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#listUserBusiness {
  margin-top: 20px;
}
</style>
